<div class="flex flex-row">
  <label class="input-main-label capitalize">
    Building *
  </label>

  <avs-location-selector
    class="flex-1"
    (changed)="patchForm({ locationId: $event! })"
    [cssClass]="cssSelectorClass()"
    [value]="form().locationId"
  />
</div>


@if (type() === 'floor' || type() === 'room') {
  @if (form().locationId) {
    <div class="flex flex-row">
      <label class="input-main-label">
        Floor {{ allRequired() ? '*' : '' }}
      </label>

      <avs-space-selector
        class="flex-1"
        (changed)="patchForm({ floorId: $event!, roomId: undefined })"
        [cssClass]="cssSelectorClass()"
        [location]="form().locationId!"
        [type]="eSpaceType.FLOOR"
        [value]="form().floorId"
      />
    </div>
  }

  @if (form().floorId && type() === 'room') {
    <div class="flex flex-row">
      <label class="input-main-label">
        Room {{ allRequired() ? '*' : '' }}
      </label>

      <avs-space-selector
        class="flex-1"
        (changed)="patchForm({ roomId: $event! })"
        [cssClass]="cssSelectorClass()"
        [location]="form().locationId!"
        [parent]="form().floorId"
        [type]="eSpaceType.ROOM"
        [value]="form().roomId"
      />
    </div>
  }
}
